import { Popper } from "@mui/material";
import { useState } from "react";
import AddFavorites from "../AddFavorites/AddFavorites";

export default function AddOrRemoveMyList({ search, categoryname, pairingId, handleRemove }) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const open = Boolean(anchorEl);

  return (
    categoryname ? <span className='icon-full_heart' style={{ cursor: 'pointer' }} onClick={handleRemove}></span> :
      <>
        <span className='icon-heart-outline' style={{ cursor: 'pointer' }} onClick={handleClick}></span>
        <Popper id='full-heart' open={open} anchorEl={anchorEl}>
          <AddFavorites search={search} pairingId={pairingId} toggleDisplay={handleClick} />
        </Popper>
      </>
  );
};